import { useQuery } from '@tanstack/react-query'
import { services } from '@opallabs/api/v2'
import { OpalApiResponseDocument } from '../../../schema'
import { globalQueryKeys } from '../../queryKeys'

type ReadServicesResponse = OpalApiResponseDocument<'ReadServicesV2', 200>

/**
 * The workspace's channels, with the accounts and artwork needed to draw a
 * channel mark.
 *
 * `filter[brand_id]` takes `null` alongside the workspace so the shared
 * channels every workspace inherits come back too.
 */
export const useReadServices = <T = ReadServicesResponse>({
  select,
  workspaceId,
}: {
  select?: (data: ReadServicesResponse) => T
  /** The numeric workspace id the v2 endpoint takes. */
  workspaceId: string
}) =>
  useQuery({
    queryKey: globalQueryKeys.services(workspaceId),
    queryFn: () =>
      services.read({
        params: {
          query: {
            filter: { brand_id: ['null', workspaceId] },
            include: ['accounts', 'asset_reference'],
            page: { limit: 500, offset: 0 },
          },
        },
      }),
    select,
  })
